













import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SjyjNavLeft extends Vue {
  @Prop()
  private cState;
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @description 跳转智能看舌
   */
  private jumpTongueList() {
    localStorage.setItem(
      "tongueListFilters",
      JSON.stringify({
        hospital_ids: [],
        范围: [],
        search: "",
        性别: "",
        开始时间: "",
        结束时间: "",
        年龄段: [],
        timeWay: "",
        time: [],
        条件: "",
        研究指标: [],
        自定义年龄: [false],
        时间段: "",
        自定义时间段: [false, []],
        currentPage: 1,
        orderField: "创建时间",
        orderValue: 0,
        pageCount: 12,
        primaryFilters: {},
        totalCount: 0,
        ifPrimarySearched: false,
      })
    );
    this.$router.push("/main/tongue/tongue-list");
  }
}
